import { post } from './request'

// 项目奖保存草稿
export const increasedProjectAddDraft = (params) => {
  return post('/service/i/web/stProjectAward/addDraft', params, { domainName: 'api' })
}
// 待审核撤回草稿
export const increasedProjectWithdraw = (params) => {
  return post('/service/i/web/stProjectAward/withdraw', params, { domainName: 'api' })
}
// 通知未读数
export const increasedMessagePushUnread = (params) => {
  return post('/service/i/web/messagePush/unread', params, { domainName: 'api' })
}
// 通知已读
export const increasedMessagePushRead = (params) => {
  return post('/service/i/web/messagePush/read', params, { domainName: 'api' })
}
// 通知列表
export const increasedMessagePushGetWebPage = (params) => {
  return post('/service/i/web/messagePush/getWebPage', params, { domainName: 'api' })
}
// 单条通知详情
export const increasedMessagePushGetDetail = (params) => {
  return post('/service/i/manager/messagePush/getDetail', params, { domainName: 'api' })
}

// 文件模板下载
export const increasedGetWebFiles = (params) => {
  return post('/service/stTemplateFile/getWebFiles', params, { domainName: 'api' })
}
// 获取文案
export const increasedGetofficial = (params) => {
  return post('/service/stTemplateFile/getofficial', params, { domainName: 'api' })
}

// 个人奖保存草稿
export const increasedPersonalAddDraft = (params) => {
  return post('/service/i/web/personal/addDraft', params, { domainName: 'api' })
}
// 待审核撤回草稿
export const increasedPersonalWithdraw = (params) => {
  return post('/service/i/web/personal/withdraw', params, { domainName: 'api' })
}

// 获奖信息查询
export const increasedPersonalGetBatchYears = (params) => {
  return post('/service/web/batch/getBatchYears', params, { domainName: 'api' })
}

export const increasedProjectGetGenerate = (params) => {
  return post('/service/web/project/getGenerate', params, { domainName: 'api' })
}
export const increasedPersonageGetGenerate = (params) => {
  return post('/service/web/personage/getGenerate', params, { domainName: 'api' })
}

// 电子证书查询
export const increasedGetAllDetail = (params) => {
  return post('/service/web/confirm/getAllDetail', params, { domainName: 'api' })
}

// 获取证书路径
export const increasedGetPath = (params) => {
  return post('/service/web/confirm/getPath', params, { domainName: 'api' })
}
